// extracted by mini-css-extract-plugin
export default {"logoPortal":"Logo_logoPortal__qsPBL","logoSoma":"Logo_logoSoma__yLv9k"};